import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'unistore/react'
import i18n from 'i18next'
import injectSheet from 'react-jss'
import cx from 'classnames'
import Dropzone from 'react-dropzone'
import {Close, Upload as UploadIcon} from '../Icons/index.jsx'
import Spinner from '../Components/Spinner.jsx'

import * as actions from '../helpers/actions.jsx'
import Upload, {filePropTypes} from './Upload.jsx'

const isIE11 = window.navigator.userAgent.includes('Trident')
const isWin = window.navigator.userAgent.includes('MSIE')

// const accept = '.doc,.dot,.docx,.docm,.dotx,.dotm,.rtf,.odt,.ott,.pdf,.xls,.xlt,.xlsx,.xlsm,.xltx,.xltm,.ods,.ots,.tsv,.ppt,.pps,.pot,.pptx,.pptm,.ppsx,.ppsm,.potx,.potm,.odp,.otp,.xml,.zip,.htm,.html,.xhtml,.xml,.dtd,.json,.yaml,.yml,.pdf,.bmp,.png,.gif,.jpeg,.jpg,.tiff,.xliff,.sdlxliff,.tmx,.ttx,.mif,.idml,.icml,.xml,.dita,.properties,.resx,.xml,.sxml,.txml,.dita,.Android xml,.strings,.srt,.wix,.po,.g,.ts,.txt.,.xlf,.mp4,.mp3,.avi,.wav,.mkv,.mov,.aiff,.jpg,.jpeg,.tif,.tiff,.png,.gif,.bmp'.split(',');

class Uploader extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    //
    modal: PropTypes.bool.isRequired,
    wordCountEnabled: PropTypes.bool.isRequired,
    contactForm: PropTypes.bool.isRequired,
    headerLabel: PropTypes.string,
    submitLabel: PropTypes.string,
    // store props
    files: PropTypes.arrayOf(PropTypes.shape(filePropTypes)).isRequired,
    // store actions
    showUploader: PropTypes.func.isRequired,
    addFile: PropTypes.func.isRequired,
    uploadFile: PropTypes.func.isRequired,
  }

  static defaultProps = {
    contactForm: false,
    headerLabel: '',
    submitLabel: '',
  }

  // prevent scrolling under modal
  componentDidMount = () => {
    const {modal} = this.props
    if (modal) document.body.style.overflow = 'hidden'
  }

  componentWillUnmount = () => {
    const {modal} = this.props
    if (modal) document.body.style.overflow = 'auto'
  }

  showUploader = (show) => () => {
    const {files} = this.props

    const uploading = files.find((file) => file.uploading)
    if (uploading) return

    this.props.showUploader(show)
  }

  onDrop = (files) => {
    const {addFile, uploadFile, wordCountEnabled, contactForm} = this.props

    for (const file of files) {
      addFile(file, wordCountEnabled)
      uploadFile(file, wordCountEnabled, contactForm)
    }
  }

  // everything but data-upload must trigger the dialog
  onClick = (event) => {
    const targetInsideDataUpload = event.target.closest('[data-upload]')
    if (targetInsideDataUpload) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }

  debugCount = (event) => {
    if (!event.shiftKey) return

    const {files} = this.props
    const pending = files.filter((file) => file.uploading).length
    const total = files.length
    const count = files
      .filter((file) => !file.uploading && !file.uploadFailed)
      .map((file) => file.count)
      .reduce((a, b) => a + b, 0)
    alert(`${count} words (${total - pending}/${total} files processed)`)
  }

  render = () => {
    const {classes, modal, headerLabel, submitLabel, contactForm} = this.props
    let {files} = this.props
    const {onDrop} = this
    const uploading = files.find((file) => file.uploading)

    // in contactform uploader deal only with files contactForm=true
    if (contactForm) files = files.filter((file) => file.fromContactForm)
    else files = files.filter((file) => !file.fromContactForm)

    const modalOverlayStyle = {
      zIndex: 101,
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    }
    const modalCardStyle = {
      display: 'inline-flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      borderRadius: 2,
      zIndex: 102,
      position: 'fixed',
      width: 736,
      maxWidth: '100%',
      maxHeight: '70%',
      top: '15%',
      left: 0,
      right: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      boxShadow: '0 0 0 1px #abb3bd, 0 8px 12px rgba(0,0,0,.16)',
    }
    const modalHeaderStyle = {
      margin: 0,
      position: 'relative',
      padding: '16px 24px',
      boxShadow: '0 1px #ccd4de',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    }
    const modalFooterStyle = {
      position: 'relative',
      padding: '8px 24px',
      boxShadow: '0 -1px #ccd4de',
      display: 'flex',
      justifyContent: 'flex-end',
    }

    return (
      <>
        {modal ? (
          <div style={modalOverlayStyle} onClick={this.showUploader(false)} />
        ) : null}

        <div
          className={modal ? classes.rootModal : classes.root}
          style={modal ? modalCardStyle : undefined}
        >
          {!!modal && (
            <header className={classes.header} style={modalHeaderStyle}>
              <h6 id="upload-label" style={{margin: 0}}>{headerLabel}</h6>
              {!uploading && <Close onClick={this.showUploader(false)} style={{cursor: 'pointer'}} />}
            </header>
          )}

          <Dropzone onDrop={onDrop} multiple={true}>
            {({getRootProps, getInputProps, isDragActive}) => {
              const rootProps = getRootProps({onClick: this.onClick})
              const inputProps = getInputProps()

              const dropzoneInlineStyle = {
                position: 'relative',
                minHeight: 250,
                overflow: 'auto',
                margin: 24,
                padding: 24,
                backgroundColor: '#f2f5f7',
                outline: '2px dashed #ccd4de',
                transition: 'border-color .25s ease-in-out',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
              }
              const dropcopyInlineStyle = files.length
                ? {
                    margin: 'auto',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    userSelect: 'none',
                    fontSize: 16,
                  }
                : {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontSize: 20,
                    lineHeight: '24px',
                    userSelect: 'none',
                  }
              const browseSpanStyle = {
                marginLeft: 5,
                cursor: 'pointer',
                color: '#0055B8',
                textDecoration: 'underline',
              }
              return (
                <div
                  className={classes.dropzone}
                  style={dropzoneInlineStyle}
                  {...rootProps}
                  role="button"
                >
                  <input {...inputProps} />

                  {!!files.length &&
                    files.map((file, index) => (
                      <Upload key={index} {...file} contactForm={contactForm} />
                    ))}

                  <span
                    className={cx(
                      files.length ? classes.dropcopyBottom : classes.dropcopy,
                    )}
                    style={dropcopyInlineStyle}
                  >
                    {isDragActive ? (
                      <p className={classes.draggingFiles}>
                        {i18n.t('Components.Uploader.helpLine2')}
                      </p>
                    ) : (
                      <>
                        <UploadIcon style={{fill: '#aaa', width: 36, height: 'auto', marginBottom: 12}} />
                        <div>
                          <span>{i18n.t('Components.Uploader.dragAndDrop')}</span>
                          <span style={browseSpanStyle}>
                            {i18n.t('Components.Uploader.dragAndDropBrowser')}
                          </span>
                        </div>
                      </>
                    )}
                  </span>
                </div>
              )
            }}
          </Dropzone>

          {!!modal && (
            <footer
              className={classes.footer}
              style={modalFooterStyle}
              onClick={this.debugCount}
            >
              <button
                className={'button button--compact'}
                onClick={this.showUploader(false)}
              >
                {!uploading ? submitLabel : <Spinner isWhite={true} />}
              </button>
            </footer>
          )}
        </div>
      </>
    )
  }
}

const Component = connect(['files'], actions)(Uploader)

export default injectSheet({
  modal: {
    zIndex: 101,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    content: '" "',
  },
  root: {
    width: '100%',
    display: 'inline-flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: 2,
    overflow: isWin ? 'scroll' : undefined,
  },
  rootModal: {
    display: 'inline-flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: 2,
    overflow: isWin ? 'scroll' : undefined,
    height: isIE11 ? '100%' : undefined,
    zIndex: 102,
    position: 'fixed',
    width: 736,
    maxWidth: '100%',
    maxHeight: 'calc(70%)',
    top: '15%',
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    boxShadow: '0 0 0 1px #abb3bd, 0 8px 12px rgba(0,0,0,.16)',
  },
  header: {
    margin: 0,
    position: 'relative',
    padding: '16px 24px',
    boxShadow: '0 1px #ccd4de',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    '& > div': {
      cursor: 'pointer',
    },
  },
  dropzone: {
    position: 'relative',
    minHeight: 250,
    overflow: 'auto',
    margin: 24,
    padding: 24,
    backgroundColor: '#f2f5f7',
    outline: '2px dashed #ccd4de',
    transition: 'border-color .25s ease-in-out',
    cursor: 'pointer',
  },
  dropcopy: {
    display: 'block',
    marginTop: 50,
    textAlign: 'center',
    fontSize: 20,
    userSelect: 'none',
    lineHeight: '24px',
    padding: [15, 0],
    '& svg': {
      fill: '#aaa',
      width: 36,
      height: 'auto',
    },
    '& > span:nth-of-type(2)': {
      marginLeft: 5,
      cursor: 'pointer',
      color: '#0055B8',
      textDecoration: 'underline',
    },
  },
  dropcopyBottom: {
    // position: 'absolute',
    // bottom: 10,
    // left: 0,
    // right: 0,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    userSelect: 'none',
    '& svg': {
      fill: '#aaa',
      width: 24,
      height: 'auto',
      marginRight: 10,
    },
    '& > span:nth-of-type(2)': {
      marginLeft: 5,
      cursor: 'pointer',
      color: '#0055B8',
      textDecoration: 'underline',
    },
  },
  draggingFiles: {
    color: '#0055b8',
    textAlign: 'center',
    fontSize: 20,
    lineHeight: '24px',
  },
  footer: {
    position: 'relative',
    padding: '8px 24px',
    boxShadow: '0 -1px #ccd4de',
    display: 'flex',
    justifyContent: 'flex-end',
  },
})(Component)
